import { render, staticRenderFns } from "./DefectPicker.vue?vue&type=template&id=0e2c7cef&scoped=true&"
import script from "./DefectPicker.vue?vue&type=script&lang=ts&"
export * from "./DefectPicker.vue?vue&type=script&lang=ts&"
import style0 from "./DefectPicker.vue?vue&type=style&index=0&id=0e2c7cef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c7cef",
  null
  
)

export default component.exports